import axios, { AxiosResponse } from 'axios';
import * as utils from '../apiUtils';
import {
  AdminJohaisetsuCompanyMasterAbilityIndexResponse,
  AdminJohaisetsuCompanyMasterAbilityUpdateResponse,
} from '@/models/apis/johaisetsuCompanyMasterAbility/adminJohaisetsuCompanyMasterAbilityResponse';
import {
  AdminJohaisetsuCompanyMasterAbilityUpdateParams,
} from '@/models/apis/johaisetsuCompanyMasterAbility/adminJohaisetsuCompanyMasterAbilityRequest';

export default {
  adminIndex(): Promise<AxiosResponse<AdminJohaisetsuCompanyMasterAbilityIndexResponse>> {
    return axios.get(utils.getApiUrl('/admin/johaisetsu_company_master_abilities'));
  },
  adminUpdate(
    id: number,
    params: AdminJohaisetsuCompanyMasterAbilityUpdateParams,
  ): Promise<AxiosResponse<AdminJohaisetsuCompanyMasterAbilityUpdateResponse>> {
    return axios.put(utils.getApiUrl(`/admin/johaisetsu_company_master_abilities/${id}`), params);
  },
};
